import { apiService } from '../api';
import { SessionClass } from '../../types/sessions';

export interface CreateClassInput {
  name: string;
  description?: string;
  isTerminal?: boolean;
}

export interface UpdateClassInput {
  name?: string;
  description?: string;
  isTerminal?: boolean;
  isActive?: boolean;
}

/**
 * Talks to the NEW /api/classes endpoints with displayOrder / isTerminal.
 * The legacy /administration/classes endpoint stays for unrelated consumers.
 */
export const classesApi = {
  // `relationship` only affects Teacher-role callers (BE ignores it for
  // everyone else). Pass 'class-teacher' on attendance surfaces where the
  // homeroom owns the action, 'subject-teacher' on marks surfaces, or
  // omit on generic dropdowns.
  list: async (opts: { relationship?: 'class-teacher' | 'subject-teacher' } = {}) => {
    const response = await apiService.get<SessionClass[]>(
      '/classes',
      opts.relationship ? { relationship: opts.relationship } : undefined
    );
    return response.data ?? [];
  },

  get: async (id: string) => {
    const response = await apiService.get<SessionClass>(`/classes/${id}`);
    return response.data!;
  },

  create: async (input: CreateClassInput) => {
    const response = await apiService.post<SessionClass>('/classes', input);
    return response.data!;
  },

  update: async (id: string, input: UpdateClassInput) => {
    const response = await apiService.put<SessionClass>(`/classes/${id}`, input);
    return response.data!;
  },

  reorder: async (orderedClassIds: string[]) => {
    const response = await apiService.post<SessionClass[]>('/classes/reorder', { orderedClassIds });
    return response.data ?? [];
  },

  deactivate: async (id: string) => {
    const response = await apiService.delete<SessionClass>(`/classes/${id}`);
    return response.data!;
  }
};
